import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

const impressum = {
  company: "Autohaus Barwinski by Spitzer und Demirci GmbH",
  address: "Normannenstraße 22, 41462 Neuss",
  phone: "02131 544154",
  email: "kfz-spitzer@gmx.de",
  managing: "Vitali Spitzer, Taner Demirci (Kfz-Meister)",
  court: "Amtsgericht Neuss",
  vat: "—",
  regNum: "—",
};

export function LegalDialog({ open, onOpenChange, kind }) {
  const isImpressum = kind === "impressum";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={`legal-dialog-${kind}`}
        className="max-w-3xl bg-[#0f0f12] border border-zinc-800 text-white rounded-none p-0 max-h-[85vh] overflow-y-auto"
      >
        <DialogHeader className="px-8 pt-8 pb-4 border-b border-zinc-800">
          <div className="text-[11px] tracking-[0.4em] uppercase gold-text mb-2">
            — {isImpressum ? "Rechtliches" : "Datenschutz"}
          </div>
          <DialogTitle className="font-display text-3xl md:text-4xl uppercase tracking-tight">
            {isImpressum ? "Impressum" : "Datenschutzerklärung"}
          </DialogTitle>
        </DialogHeader>

        <div className="px-8 py-6 text-sm text-zinc-300 leading-relaxed space-y-4">
          {isImpressum ? <ImpressumBody /> : <DatenschutzBody />}
        </div>
      </DialogContent>
    </Dialog>
  );
}

function ImpressumBody() {
  return (
    <>
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          Anbieter
        </div>
        <div className="mt-1 text-white font-medium">{impressum.company}</div>
        <div>{impressum.address}</div>
      </div>
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          Kontakt
        </div>
        <div>Telefon: {impressum.phone}</div>
        <div>E-Mail: {impressum.email}</div>
      </div>
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          Vertretungsberechtigte Geschäftsführer
        </div>
        <div>{impressum.managing}</div>
      </div>
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          Registereintrag
        </div>
        <div>Registergericht: {impressum.court}</div>
        <div>Registernummer: {impressum.regNum}</div>
      </div>
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          Umsatzsteuer-ID
        </div>
        <div>{impressum.vat}</div>
      </div>
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
        </div>
        <div>{impressum.managing}</div>
        <div>{impressum.address}</div>
      </div>
      <div className="pt-4 border-t border-zinc-800 text-xs text-zinc-500">
        <p>
          Hinweis: Die oben markierten Felder (Registernummer, USt-ID) sind
          Platzhalter und werden vom Betreiber mit den offiziellen Angaben
          ergänzt.
        </p>
        <p className="mt-2">
          EU-Streitschlichtung: Die Europäische Kommission stellt eine Plattform
          zur Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noreferrer"
            className="gold-text hover:underline"
          >
            ec.europa.eu/consumers/odr
          </a>
          . Wir sind nicht verpflichtet und nicht bereit, an
          Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </div>
    </>
  );
}

function DatenschutzBody() {
  return (
    <>
      <p>
        Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir verarbeiten
        Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen
        (DSGVO, BDSG, TMG).
      </p>

      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mt-2">
          1. Verantwortlicher
        </div>
        <div>{impressum.company}</div>
        <div>{impressum.address}</div>
        <div>Telefon: {impressum.phone} · E-Mail: {impressum.email}</div>
      </div>

      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          2. Verarbeitung bei Terminanfragen
        </div>
        <p>
          Wenn Sie über unser Kontaktformular einen Termin anfragen, werden
          folgende Daten verarbeitet: Name, E-Mail, Telefonnummer, Fahrzeug
          (optional), gewünschte Leistung, Wunschtermin und Ihre Nachricht.
          Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Durchführung
          vorvertraglicher Maßnahmen).
        </p>
        <p>
          Zweck: Terminvereinbarung, Rückfragen und Abstimmung. Zur Zustellung
          der Bestätigungs-E-Mail nutzen wir den Dienst Resend
          (Resend, Inc., USA).
        </p>
      </div>

      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          3. Speicherdauer
        </div>
        <p>
          Ihre Anfragedaten werden gelöscht, sobald sie für den Zweck nicht mehr
          erforderlich sind — spätestens nach Ablauf gesetzlicher
          Aufbewahrungsfristen (6 bzw. 10 Jahre gemäß HGB/AO, soweit
          einschlägig).
        </p>
      </div>

      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          4. Empfänger / Auftragsverarbeiter
        </div>
        <p>
          E-Mail-Versand: Resend, Inc. · Hosting/Technik: Emergent/Preview-Infrastruktur
          · Kartenanzeige: Google Maps (Google Ireland Ltd.). Diese Anbieter
          verarbeiten Daten in unserem Auftrag bzw. stellen Inhalte auf der
          Seite bereit.
        </p>
      </div>

      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          5. Ihre Rechte
        </div>
        <p>
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung,
          Einschränkung, Widerspruch sowie Datenübertragbarkeit und das Recht,
          sich bei einer Aufsichtsbehörde zu beschweren.
        </p>
      </div>

      <div className="pt-4 border-t border-zinc-800 text-xs text-zinc-500">
        Dies ist eine vereinfachte Basis-Datenschutzerklärung für die
        Vorabveröffentlichung. Bitte vor Live-Schaltung durch einen Volljuristen
        bzw. anwaltlich geprüften DSGVO-Generator ergänzen lassen.
      </div>
    </>
  );
}
